<p-dialog-container class="popup_top_index">
    <p-dialog-header title="{{ 'SwitchAccountDialog.title' | translate }}"></p-dialog-header>
    <div class="p-dialog-content">
        <p-field-single-select
            *ngIf="company$ | async as companies"
            label="{{ 'SwitchAccountDialog.label' | translate }}"
            [value]="selectedCompanyName"
            [list]="companies"
            (valueChange)="changeValue($event, companies)"
        >
        </p-field-single-select>
    </div>
    <p-dialog-footer [btnConfig]="footerConfig"></p-dialog-footer>
</p-dialog-container>
